import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './languagePicker.scss';

interface ILangugage {
  value: string;
  label: string;
  labelShort: string;
  default: boolean;
  flag: () => JSX.Element;
}

const languages: ILangugage[] = [
  {
    value: 'en',
    label: 'English',
    labelShort: 'ENG',
    default: true,
    flag: function () {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          id='flag-icons-gb'
          viewBox='0 0 640 480'
        >
          <path fill='#012169' d='M0 0h640v480H0z' />
          <path
            fill='#FFF'
            d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z'
          />
          <path
            fill='#C8102E'
            d='m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z'
          />
          <path fill='#FFF' d='M241 0v480h160V0H241zM0 160v160h640V160H0z' />
          <path fill='#C8102E' d='M0 193v96h640v-96H0zM273 0v480h96V0h-96z' />
        </svg>
      );
    },
  },
  {
    value: 'de',
    label: 'German',
    labelShort: 'GER',
    default: true,
    flag: function () {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          id='flag-icons-de'
          viewBox='0 0 640 480'
        >
          <path fill='#ffce00' d='M0 320h640v160H0z' />
          <path fill='#000' d='M0 0h640v160H0z' />
          <path fill='#d00' d='M0 160h640v160H0z' />
        </svg>
      );
    },
  },
];
const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState<ILangugage | null>();
  const [open, setOpen] = useState<boolean>(false);

  const closeDropdown = () => {
    setOpen(false);
  };

  const toggleDropdown = () => {
    setOpen(!open);
  };
  const selectLanguage = (lang: ILangugage) => {
    localStorage.setItem('i18nextLng', lang.value);
    i18n.changeLanguage(lang.value);
    setSelected(lang);
  };

  useEffect(() => {
    const lang = languages.find((l) => l.value === i18n.language);
    setSelected(lang);
  }, [i18n.language]);

  useEffect(() => {
    setTimeout(() => {
      if (open) {
        window.addEventListener('click', closeDropdown);
      } else {
        window.removeEventListener('click', closeDropdown);
      }
    }, 0);
    return () => {
      window.removeEventListener('click', closeDropdown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div className='language-selector'>
      {selected && (
        <>
          <button onClick={toggleDropdown}>
            <span className='icon'>
              <selected.flag />
            </span>
            <span>{selected.labelShort}</span>
            <span className='dropdown-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                <path d='M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z' />
              </svg>
            </span>
          </button>
          {open && (
            <ul className='menu dropdown'>
              {languages.map((item: ILangugage) => (
                <li key={item.label}>
                  <button onClick={() => selectLanguage(item)}>
                    {item.flag()}
                    {item.label}
                    {selected.value === item.value && (
                      <span className='check-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 512 512'
                        >
                          <path d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z' />
                        </svg>
                      </span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default LanguagePicker;
